import { createContext } from "react";

export const ModalSettingsContext = createContext("");